import { useGetUsersQuery } from '../../../store/api/users/users.api'
import { FC, useEffect, useMemo, useState } from 'react'
import MultiSelect from '../select/MultiSelect'
import { ISelectData } from '../select/model'
import { createSingleSelectData } from '../../../utils/createSingleSelectData'
import { USER_ROLE } from '../../../utils/constants'
import { IValidationRequired } from '../../../validation/model'
import { IUserData } from '../../../store/api/users/model'

interface IMultiSelectUsersWhitRoleProps {
  selectedUser: ISelectData[]
  setSelectedUser: React.Dispatch<React.SetStateAction<ISelectData[]>>
  label: string
  schoolId?: number
  roleId?: string
  deleteErrormessage?: React.Dispatch<React.SetStateAction<IValidationRequired>>
  field?: string
}

const PAGE_SIZE = 500
const MultiSelectUsersWhitRole: FC<IMultiSelectUsersWhitRoleProps> = ({
  selectedUser,
  setSelectedUser,
  label,
  schoolId,
  roleId,
  deleteErrormessage,
  field
}): JSX.Element => {
  const [page, setPage] = useState<number>(1)
  const [usersData, setUsersData] = useState<ISelectData[]>([])
  const { data: users, refetch: studentsRefetch } = useGetUsersQuery({
    page,
    pageSize: PAGE_SIZE,
    roleId,
    schoolId
  })

  const getIdByRole = useMemo(() => {
    return (item: IUserData): number | undefined => {
      if (roleId === USER_ROLE.Student) {
        return item.student?.id
      }
      if (roleId === USER_ROLE.Teacher) {
        return item.teacher?.id
      }
      return item.id
    }
  }, [roleId])

  useEffect(() => {
    if (users?.data?.length > 0) {
      if (schoolId && page === 1) {
        setUsersData([
          ...users?.data?.map(item => createSingleSelectData(item.fullName, getIdByRole(item)))
        ])
      }
      setUsersData(prev => [
        ...prev,
        ...users.data.map(item => createSingleSelectData(item.fullName, getIdByRole(item)))
      ])
    } else if (schoolId && page === 1) {
      setUsersData([])
    }
  }, [users])

  useEffect(() => {
    if (page === 1) {
      studentsRefetch()
    }
  }, [page])

  return (
    <div>
      <label className='text-dark mt-5' htmlFor='exampleInputname'>
        {label}
      </label>
      <MultiSelect
        setData={setSelectedUser}
        data={usersData}
        editData={selectedUser}
        setPageByScroll={setPage}
        dataCount={users?.count}
        deleteErrormessage={deleteErrormessage}
        field={field}
        pageSize={PAGE_SIZE}
      />
    </div>
  )
}

export default MultiSelectUsersWhitRole
